import angular from 'angular';

angular.module('app.core').factory('BillingWarrant', BillingWarrant);

export default class BillingWarrant {
  constructor(billingWarrant) {
    this.billingWarrantRef = billingWarrant ? billingWarrant.billingWarrantRef : null;
    this.billingWarrantDate = billingWarrant ? billingWarrant.billingWarrantDate : null;
    this.billingWarrantFileId = billingWarrant ? billingWarrant.billingWarrantFileId : null;
  }
}
